var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.base.icon, ( _obj = {}, _obj[_vm.base.noMargin] = _vm.noMargin, _obj )],style:({
    width: _vm.size,
    height: _vm.size
  }),attrs:{"role":_vm.role}},[(_vm.backdrop)?_c('circle',{attrs:{"cx":_vm.circlePosition,"cy":_vm.circlePosition,"r":_vm.circleSize,"fill":"white"}}):_vm._e(),_c('use',{attrs:{"xlink:href":("#" + _vm.name)}}),(_vm.alt)?_c('desc',[_vm._v(_vm._s(_vm.alt))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }